import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
  elevated?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const GlassCard: React.FC<GlassCardProps> = ({ children, className = '', hoverable = true, elevated = false, style, onClick }) => {
  const baseStyle: React.CSSProperties = {
    background: elevated ? 'var(--glass-bg-elevated)' : 'var(--glass-bg)',
    backdropFilter: 'var(--glass-blur)',
    WebkitBackdropFilter: 'var(--glass-blur)',
    border: '1px solid var(--glass-border)',
    borderRadius: 'var(--radius-lg)',
    boxShadow: elevated ? 'var(--glass-shadow-elevated)' : 'var(--glass-shadow)',
    padding: 'var(--space-lg)',
    transition: 'all var(--transition-base)',
    ...style,
  };

  return (
    <div
      className={`glass-card ${hoverable ? 'glass-card--hoverable' : ''} ${className}`}
      style={baseStyle}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default GlassCard;
